import {useSettingsQuery} from '../../common/providers/ApiInterface'

export const usePlantGeneralData = (plantId?: string) => {
  return useSettingsQuery('plantDetails', [plantId], {
    enabled: !!plantId,
    gcTime: 0,
    staleTime: 0
  })
}
